import { render } from "./Promotions.vue?vue&type=template&id=76cb8709&scoped=true&ts=true"
import script from "./Promotions.vue?vue&type=script&lang=ts"
export * from "./Promotions.vue?vue&type=script&lang=ts"

import "./Promotions.vue?vue&type=style&index=0&id=76cb8709&scoped=true&lang=css"
import "./Promotions.vue?vue&type=style&index=1&id=76cb8709&lang=css"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76cb8709"]])

export default __exports__